/**
 * `learning-blocks` — Space's EXTENSIBLE learning blocks engine.
 *
 * Adding a new block type = implementing `BlockPlugin` + `registry.register()`.
 * The engine (`gradeBlock`/`gradeLesson`) NEVER changes. See the LEARNING_BLOCKS guide.
 */
export * from "./types";
export * from "./normalize";
export * from "./registry";
export * from "./engine";
export * from "./antifraud";
export * from "./blocks";

import { baseBlocks } from "./blocks";
import { BlockRegistry } from "./registry";

/** Registry loaded with the 6 base types. Starting point for the app. */
export function defaultRegistry(): BlockRegistry {
  return new BlockRegistry().registerAll(baseBlocks);
}
